import { useQuery } from '@apollo/client'
import { GET_ORDER } from 'lib/graphql/order'
import React from 'react'
import { useSelector } from 'react-redux'
import { authStateSelector } from 'store/auth/selector'
import theme from 'styles/theme'

import Icon from './Icon'

function OrderDetail({ orderId }) {
  const authState = useSelector(authStateSelector)
  const { firstName, lastName } = authState?.currentUser || {}
  const { data, loading, error } = useQuery(GET_ORDER, {
    variables: {
      orderId,
    },
  })

  const {
    orderNumber,
    subtotalPriceV2,
    lineItems,
    totalShippingPriceV2,
    totalPriceV2,
    shippingAddress,
    processedAt,
    financialStatus,
    fulfillmentStatus,
    successfulFulfillments,
  } = data?.node || {}
  return (
    <div>
      {data && (
        <>
          <h3 css={{ fontSize: '1.5rem' }}>Order {orderNumber}</h3>
          <p>
            Placed on{' '}
            {new Date(processedAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}{' '}
            at {new Date(processedAt).toLocaleTimeString('en-US')}
          </p>
          <div
            css={{
              display: 'grid',
              marginTop: '2rem',
              gap: '3rem',
              gridTemplateColumns: '2fr .75fr',
              [theme.mediumDown]: {
                gridTemplateColumns: '1fr',
              },
            }}
          >
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                overflowX: 'auto',
              }}
            >
              <table
                css={{
                  borderRadius: '4px 4px 0 0',
                  borderCollapse: 'collapse',
                  border: '1px solid #D0DCDA',
                  height: 'min-content',
                  textAlign: 'left',
                  overflow: 'auto',
                }}
              >
                <thead
                  css={{
                    background: '#134F46',
                    color: 'white',
                    [theme.mediumDown]: {
                      border: 'none',
                      clip: 'rect(0 0 0 0)',
                      height: '1px',
                      margin: '-1px',
                      overflow: 'hidden',
                      padding: 0,
                      width: '1px',
                    },
                  }}
                >
                  <tr
                    css={{
                      [theme.mediumDown]: {
                        display: 'none',
                      },
                    }}
                  >
                    <th
                      css={{
                        padding: '.75rem 1.25rem',
                      }}
                    >
                      Product
                    </th>
                    <th
                      css={{
                        padding: '.75rem 1.25rem',
                      }}
                    >
                      SKU
                    </th>
                    <th
                      css={{
                        padding: '.75rem 1.25rem',
                      }}
                    >
                      Price
                    </th>
                    <th
                      css={{
                        padding: '.75rem 1.25rem',
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      css={{
                        padding: '.75rem 1.25rem',
                      }}
                    >
                      TOTAL
                    </th>
                  </tr>
                </thead>
                <tbody
                  css={{
                    textAlign: 'right',
                  }}
                >
                  {!loading &&
                    lineItems?.edges.map(({ node }, idx) => (
                      <tr
                        key={idx}
                        css={{
                          cursor: 'pointer',
                          border: '1px solid #D0DCDA',
                          '&:hover': {
                            background: '#e1ede8',
                          },
                          [theme.mediumDown]: {
                            border: '1px solid #D0DCDA',
                          },
                        }}
                      >
                        <td
                          data-label='Product'
                          css={{
                            display: 'none',
                            padding: '1rem 1.25rem',
                            textAlign: 'left',
                            [theme.mediumDown]: {
                              display: 'block',
                              textAlign: 'right',
                              ':before': {
                                content: 'attr(data-label)',
                                float: 'left',
                                fontWeight: 'bold',
                                fontSize: '18px',
                              },
                            },
                          }}
                        />
                        <td
                          data-label={node.title}
                          css={{
                            padding: '1rem 1.25rem',
                            textAlign: 'left',
                            [theme.mediumDown]: {
                              display: 'block',
                              textAlign: 'right',
                              ':before': {
                                content: 'attr(data-label)',
                                float: 'left',
                                fontWeight: 'bold',
                              },
                            },
                          }}
                        >
                          <span
                            css={{
                              fontWeight: 'bold',
                              display: 'none',
                              [theme.mediumDown]: {
                                display: 'block',
                              },
                            }}
                          >
                            x{node.quantity}
                          </span>
                          <span
                            css={{
                              fontWeight: 'bold',
                              [theme.mediumDown]: {
                                display: 'none',
                              },
                            }}
                          >
                            {node.title}
                          </span>
                          <div css={{ marginTop: '1rem' }}>
                            {node.discountAllocations.length > 0 && (
                              <span
                                css={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                <Icon.Label />
                                <span
                                  css={{
                                    fontWeight: 'bold',
                                    fontSize: 12,
                                    marginLeft: 4,
                                  }}
                                >
                                  AGILONETEST11 (-$
                                  {node.discountAllocations[0].allocatedAmount.amount})
                                </span>
                              </span>
                            )}

                            {successfulFulfillments.length > 0 && (
                              <div
                                css={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  fontSize: '14px',
                                  background: '#E5F1EC',
                                  color: '#134F46',
                                  padding: '10px 10px',
                                  borderRadius: 4,
                                  margin: '8px 0',
                                  [theme.mediumDown]: {
                                    alignItems: 'flex-start',
                                  },
                                }}
                              >
                                <span css={{ marginBottom: '.5rem' }}>Fulfilled</span>
                                {successfulFulfillments[0].trackingInfo?.length > 0 && (
                                  <>
                                    <a
                                      href={successfulFulfillments[0].trackingInfo[0].url}
                                      target='_blank'
                                      css={{
                                        marginBottom: '.5rem',
                                        textDecoration: 'underline',
                                      }}
                                    >
                                      Track shipment{' '}
                                    </a>
                                    <span>
                                      {`${successfulFulfillments[0].trackingCompany} #${successfulFulfillments[0].trackingInfo[0].number}`}
                                    </span>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </td>
                        <td
                          data-label='SKU'
                          css={{
                            padding: '1rem 1.25rem',
                            [theme.mediumDown]: {
                              display: 'block',
                              textAlign: 'right',
                              ':before': {
                                content: 'attr(data-label)',
                                float: 'left',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                              },
                            },
                          }}
                        >
                          {node.variant?.sku}
                        </td>
                        <td
                          data-label='Price'
                          css={{
                            padding: '1rem 1.25rem',
                            [theme.mediumDown]: {
                              display: 'block',
                              textAlign: 'right',
                              ':before': {
                                content: 'attr(data-label)',
                                float: 'left',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                              },
                            },
                          }}
                        >
                          {node.discountAllocations.length > 0 ? (
                            <div css={{ display: 'flex', flexDirection: 'column' }}>
                              <span css={{ textDecorationLine: 'line-through' }}>
                                ${node.originalTotalPrice.amount}
                              </span>
                              <span css={{ marginTop: 2 }}>
                                $
                                {(
                                  parseFloat(node.originalTotalPrice.amount) -
                                  parseFloat(node.discountAllocations[0]?.allocatedAmount.amount)
                                ).toFixed(2)}
                              </span>
                            </div>
                          ) : (
                            <>${node.originalTotalPrice.amount}</>
                          )}
                        </td>
                        <td
                          css={{
                            padding: '1rem 1.25rem',
                            [theme.mediumDown]: {
                              display: 'none',
                            },
                          }}
                        >
                          {node.quantity}
                        </td>
                        <td
                          data-label='TOTAL'
                          css={{
                            padding: '1rem 1.25rem',
                            [theme.mediumDown]: {
                              display: 'block',
                              textAlign: 'right',
                              ':before': {
                                content: 'attr(data-label)',
                                float: 'left',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                              },
                            },
                          }}
                        >
                          ${' '}
                          {(
                            parseFloat(node.originalTotalPrice.amount) -
                            parseFloat(node.discountAllocations[0]?.allocatedAmount.amount || 0)
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <div
                css={{
                  marginLeft: 'auto',
                  maxWidth: 388,
                  borderRadius: 4,
                  background: '#134F46',
                  padding: '20px 37px',
                  marginTop: 24,
                  [theme.mediumDown]: {
                    padding: '1rem 1.25rem',
                    marginLeft: 0,
                  },
                }}
              >
                <div
                  css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#fff',
                    marginBottom: 16,
                  }}
                >
                  <span>Subtotal</span>
                  <span css={{ fontWeight: 'bold' }}>${subtotalPriceV2.amount}</span>
                </div>
                <div
                  css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#fff',
                    marginBottom: 16,
                  }}
                >
                  <span>
                    Shipping
                    <br />
                    <span
                      css={{
                        fontSize: 13,
                        display: 'block',
                        marginTop: 6,
                        opacity: 0.8,
                      }}
                    >
                      {' '}
                      (Free 3-5 Day Ground Shipping)
                    </span>
                  </span>
                  <span css={{ fontWeight: 'bold' }}>${totalShippingPriceV2.amount}</span>
                </div>
                <div
                  css={{
                    height: 1,
                    width: '100%',
                    background: '#fff',
                    marginBottom: 16,
                    opacity: 0.5,
                  }}
                />
                <div
                  css={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#fff',
                  }}
                >
                  <span css={{ fontWeight: 'bold' }}>TOTAL</span>
                  <span css={{ fontWeight: 'bold' }}>${totalPriceV2.amount} USD</span>
                </div>
              </div>
            </div>

            <div
              css={{
                [theme.mediumDown]: {
                  padding: '1rem',
                },
              }}
            >
              <div>
                <h3 css={{ fontSize: '1.5rem' }}>Billing Address</h3>
                <p
                  css={{
                    fontWeight: 'bold',
                  }}
                >
                  Payment Status: {financialStatus}
                </p>
                <div
                  css={{
                    margin: '1rem 0',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {firstName} {lastName}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.address1}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.city} {shippingAddress?.provinceCode} {shippingAddress?.zip}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.country}
                  </span>
                </div>
              </div>
              <div
                css={{
                  marginTop: '3rem',
                }}
              >
                <h3 css={{ fontSize: '1.5rem' }}>Shipping Address</h3>
                <p
                  css={{
                    fontWeight: 'bold',
                  }}
                >
                  Fulfillment Status: {fulfillmentStatus}
                </p>
                <div
                  css={{
                    margin: '1rem 0',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {firstName} {lastName}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.address1}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.city} {shippingAddress?.provinceCode} {shippingAddress?.zip}
                  </span>
                  <span
                    css={{
                      fontSize: '1rem',
                      marginBottom: '.5rem',
                    }}
                  >
                    {shippingAddress?.country}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default OrderDetail
